import { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'

import { addDoc, deleteDoc } from 'lib/firestore'

export default function UserDialog({ data, onClose }) {
  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({ defaultValues: data })
  const [open, setOpen] = useState(false)

  useEffect(() => {
    setOpen(true)
  }, [])

  const onSubmit = values => {
    return addDoc('admins', values).then(() => setOpen(false))
  }

  const handleDelete = async () => {
    await deleteDoc(`admins/${data.id}`)
    setOpen(false)
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)} TransitionProps={{ onExited: onClose }}>
      <DialogTitle>管理者追加</DialogTitle>
      <DialogContent>
        <Controller
          name="email"
          defaultValue=""
          control={control}
          rules={{
            required: true,
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'メールアドレスの形式で入力してください',
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              sx={{ mb: 2 }}
              label="メールアドレス"
              disabled={Boolean(data.id)}
              helperText={errors.email && errors.email.message}
            />
          )}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 1 }}>
        <div style={{ flex: 1 }} />
        <Button onClick={() => setOpen(false)}>キャンセル</Button>
        {data.id ? (
          <Button color="secondary" onClick={() => handleDelete()}>
            削除する
          </Button>
        ) : (
          <Button color="primary" onClick={handleSubmit(onSubmit)} disabled={isSubmitting}>
            追加する
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
